import { mq, screen } from "lib/media-query";
import React, { memo } from "react";
import { CollapserWithArrow } from "components/CollapserWithArrow";
import styled, { css } from "styled-components";
import { theme as activeTheme } from "config/themes";

const Container = styled.div`
    background: white;
    margin-bottom: 1px;

    ${mq.from(screen.LG)`
    margin-bottom: 7px;
  `}
    ${({ proefritCampaign, isGroupContainer }) =>
        proefritCampaign && !isGroupContainer
            ? css`
                  margin-bottom: 0px !important;
              `
            : ""}

  ${({ isGroupContainer, theme }) =>
        isGroupContainer
            ? css`
                  clear: both;
                  background: ${theme.colors.tertiary[300]};

                  ${mq.from(screen.LG)`
            margin: 0 0 8px 0;
          `}
              `
            : ""}
`;

const Content = styled.div`
    ${({ isGroupContainer }) =>
        isGroupContainer
            ? "padding: 0 7px 7px 7px;"
            : `
      padding: 0 15px 15px 15px;
        ${mq.from(screen.LG)`
              padding: 0 10px 24px 10px;
        `}
  `}
    ${({ proefritCampaign, isGroupContainer }) =>
        proefritCampaign && !isGroupContainer
            ? "padding: 18px 10px 15px 10px !important;"
            : `

  `}
`;

const customGroupContainerStyles = `
         color: #333333;
         font-size: 12px;
         font-weight: 600;
         letter-spacing: 0.75px;
         text-transform: uppercase;
         background-color: transparent;
         padding: 10px 12px 10px 16px;

`;

const FilterContainer = memo(
    ({
        label = "",
        testId = "",
        isGroupContainer = false,
        isOpen = false,
        showTooltip,
        dataTestId = "filter-container",
        filterTooltipName,
        children,
        proefritCampaign = false
    }) => {
        return (
            <Container
                proefritCampaign={proefritCampaign}
                isGroupContainer={isGroupContainer}
                data-testid={dataTestId}
            >
                <CollapserWithArrow
                    groupContainer={isGroupContainer}
                    label={label}
                    isOpen={isOpen}
                    showTooltip={showTooltip}
                    filterTooltipName={filterTooltipName}
                    proefritCampaign={proefritCampaign}
                    testId={testId}
                    arrowColor={isGroupContainer && activeTheme.colors.tertiary[800]}
                    customButtonStyles={isGroupContainer && customGroupContainerStyles}
                >
                    <Content
                        proefritCampaign={proefritCampaign}
                        isGroupContainer={isGroupContainer}
                    >
                        {children}
                    </Content>
                </CollapserWithArrow>
            </Container>
        );
    }
);

export default FilterContainer;
